import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Container,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useAppSelectStyles } from './styles';

const AppSelect = ({ ...props }) => {
  const {
    label,
    options,
    name,
    error,
    errorMessage,
    value,
    onBlur,
    onClick,
    onChange,
    hidden,
    testId,
  } = props;
  const classes = useAppSelectStyles({ hidden });

  const handleChange = (event) => {
    onChange(event);
  };

  const handleBlur = (event) => {
    onBlur(event);
  };

  const handleClick = (event) => {
    onClick(event);
  };

  return (
    <Container>
      <FormControl
        className={classes.formControl}
        variant="outlined"
        size="small"
        error={error}
      >
        <InputLabel id={label}>{label}</InputLabel>
        <Select
          data-testid={testId}
          data-cy={`select${name}`}
          labelId={label}
          label={label}
          name={name}
          value={value}
          IconComponent={KeyboardArrowDownIcon}
          onChange={handleChange}
          onClick={handleClick}
          onBlur={handleBlur}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          }}
        >
          {options.map((option, key) => (
            <MenuItem
              value={option.id}
              key={key}
              data-cy={option.name.split(' ').join('')}
            >
              {option.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText className={classes.errorText}>
          {errorMessage}
        </FormHelperText>
      </FormControl>
    </Container>
  );
};

AppSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
  testId: PropTypes.string,
};

export default AppSelect;
